import createArticleSubmission from "./createArticleSubmission";
import trackArticleSubmission from "./trackArticleSubmission";

const articleSubmissionWebsiteServices = {
  createArticleSubmission,
  trackArticleSubmission,
};

export default articleSubmissionWebsiteServices;
